<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.searchValue" class="input-with-select" size="small">
                        <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
                            <el-option label="用户ID" :value="1"></el-option>
                            <el-option label="用户名" :value="2"></el-option>
                            <!-- <el-option label="领奖地" :value="3"></el-option> -->
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.isReward" placeholder="请选择" size="small">
                        <el-option label="不限制是否发奖" value=""></el-option>
                        <el-option label="仅看已发奖的" :value="1"></el-option>
                        <el-option label="仅看未发奖的" :value="2"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.status" placeholder="请选择" size="small">
                        <el-option label="不限制用户状态" value=""></el-option>
                        <el-option label="仅看有效的" :value="1"></el-option>
                        <el-option label="仅看无效的" :value="0"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.sort" placeholder="请选择" size="small">
                        <el-option label="综合排序(与排行榜顺序一致)" :value="3"></el-option>
                        <el-option label="优先展示秀动统计UV高的" :value="1"></el-option>
                        <el-option label="优先展示秀动统计PV高的" :value="2"></el-option>
                        <el-option label="优先展示百度统计UV高的" :value="4"></el-option>
                        <el-option label="优先展示百度统计PV高的" :value="5"></el-option>
                    </el-select>
                </el-col>
                <!-- <el-col :xs="24" :sm="12" :md="10" :lg="10" :xl="6">
                    <el-date-picker v-model="datetimerange" type="datetimerange" start-placeholder="参与时间"
                        end-placeholder="参与时间" value-format="yyyy-MM-dd HH:mm:ss" size="small"
                        :default-time="['00:00:00', '23:59:59']" unlink-panels>
                    </el-date-picker>
                </el-col> -->
                <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div v-if="dataList && dataList.length > 0" class="page-btns-box">
            <!-- <el-button
                v-if="$utils.have('/shareActivity/joinedUser/importAwardUser')"
                type="primary"
                icon="el-icon-upload2"
                @click="batchImport"
                size="small"
                >导入获奖用户</el-button
            > -->
            <el-button v-if="$utils.have('/shareActivity/joinedUser/award')" type="primary"
                @click="handleAward" size="small" >发放奖品</el-button>
            <el-button v-if="$utils.have('/shareActivity/joinedUser/createExport')" type="primary"
                @click="download" size="small" :loading="downLoading">导出参与用户详情</el-button>
        </div>
        <div class="page-list-box">
            <el-table :data="dataList" border style="width: 100%" v-loading="listLoading" size="small" stripe
                @selection-change="handleSelectionChange">
                <el-table-column type="selection"></el-table-column>
                <el-table-column label="状态">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.status == 1" type="success" size="mini">有效</el-tag>
                        <el-tag v-else type="info" size="mini">无效</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="是否发奖">
                    <template slot-scope="scope">
                        <span v-if="scope.row.prizeId" class="color-success">是</span>
                        <span v-else>否</span>
                    </template>
                </el-table-column>
                <el-table-column label="用户确认">
                    <template slot-scope="scope">
                        <span v-if="scope.row.isConfirm == 1" class="color-success">已确认</span>
                        <span v-else>未确认</span>
                    </template>
                </el-table-column>
                <el-table-column prop="userId" label="用户ID" min-width="100"></el-table-column>
                <el-table-column label="用户名称" min-width="120">
                    <template slot-scope="scope">
                        <el-tooltip :content="scope.row.userName" placement="top">
                            <span class="ellipsis">{{ scope.row.userName }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column prop="telephone" label="手机号" min-width="110"></el-table-column>
                <el-table-column label="进度">
                    <template slot-scope="{row} = scope">
                        {{ row.progressMade }}%
                    </template>
                </el-table-column>
                <!-- <el-table-column label="领奖地/收货地址" min-width="150">
                    <template slot-scope="scope">
                        <el-tooltip :content="scope.row.awardPlace" placement="top">
                            <span class="ellipsis">{{ scope.row.awardPlace }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column> -->
                <el-table-column label="UV" min-width="120">
                    <template slot-scope="{row} = scope">
                        <p>秀动：{{ row.uv }}</p>
                        <p>百度：{{ row.bdUv }}</p>
                    </template>
                </el-table-column>
                <el-table-column label="PV" min-width="120">
                    <template slot-scope="{row} = scope">
                        <p>秀动：{{ row.pv }}</p>
                        <p>百度：{{ row.bdPv }}</p>
                    </template>
                </el-table-column>
                <el-table-column label="注册转化" min-width="120">
                    <template slot-scope="{row} = scope">
                        <p>注册人数：{{ row.registerCount }}</p>
                        <p>转化率：{{ row.userCr }}</p>
                    </template>
                </el-table-column>
                <el-table-column label="下单转化" min-width="120">
                    <template slot-scope="{row} = scope">
                        <p>下单人数：{{ row.orderUserCount }}</p>
                        <p>转化率：{{ row.orderCr }}</p>
                    </template>
                </el-table-column>
                <el-table-column label="销售转化" min-width="120">
                    <template slot-scope="{row} = scope">
                        <p>订单数：{{ row.orderCount }}</p>
                        <p>销售额：{{ row.saleAmountFormat }}</p>
                    </template>
                </el-table-column>
                <el-table-column prop="trackPath" label="跟踪参数" min-width="120" show-overflow-tooltip></el-table-column>
                <el-table-column prop="createTime" label="参与时间" min-width="150"></el-table-column>
                <el-table-column fixed="right" label="操作" width="80">
                    <template slot-scope="scope">
                        <el-button v-if="$utils.have('/share/activity/update')" type="text" size="small"
                            @click="setFun(scope.row.id, scope.row.status)">
                            <span v-if="scope.row.status === 1" class="color-danger">设为无效</span>
                            <span v-else>设为有效</span>
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination background @size-change="handleSizeChange" @current-change="getDataList"
                :current-page.sync="params.pageNo" :page-sizes="$pageSizes" :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next" :total="data.totalCount || 0">
            </el-pagination>
        </div>

        <!-- <batch-import ref="batchImport" @update="getDataList" :activityId="id"></batch-import> -->
        <confirm-award ref="confirmAward" @update="getDataList" :shareActivityId="id"></confirm-award>
    </div>
</template>
<script>
import ConfirmAward from './components/confirmAward.vue';
// import {getHttp} from '@/assets/js/getRequest.js';
// import BatchImport from './components/batchImport';

const defaultParams = {
    pageNo: 1,
    searchType: 1,
    searchValue: "",
    status: "",
    sort: 3,
    isReward: '',
    startTime: null,
    endTime: null,
};
export default {
    props: {
        id: {
            type: [Number, String],
            default: ''
        }
    },
    components:{ConfirmAward},
    data() {
        return {
            data: null,
            dataList: null,
            params: {
                ...defaultParams,
                pageSize: this.$pageSizes[0],
            },
            datetimerange: [],
            listLoading: true,
            downLoading: false,
            joinUserIds: []
        };
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/shareActivity/joinedUser/list",
                method: "POST",
                data: {
                    ...this.params,
                    shareActivityId: parseInt(this.id),
                    startTime: this.datetimerange && this.datetimerange[0] || null,
                    endTime: this.datetimerange && this.datetimerange[1] || null
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.datetimerange = [];
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        //导入事件
        // batchImport(){
        //     this.$refs.batchImport.show();
        // },       
        setFun(id, status) {
            this.listLoading = true;
            this.$request({
                url: '/shareActivity/joinedUser/updateStatus',
                method: "POST",
                params: {
                    id: id,
                    status: status == 0 ? 1 : 0
                },
            }).then(res => {
                const { state, msg } = res.data;
                if (state == 1) {
                    this.$message.success('操作成功');
                    this.getDataList();

                } else {
                    this.$message.error(msg || "请求失败");
                }
            }).finally(() => {
                this.listLoading = false;
            })
        },

        //导出
        async download() {
            this.downLoading = true;
            this.$request({
                url: '/shareActivity/joinedUser/createExport',
                method: "POST",
                data: {
                    ...this.params,
                    shareActivityId: parseInt(this.id),
                    startTime: this.datetimerange && this.datetimerange[0] || null,
                    endTime: this.datetimerange && this.datetimerange[1] || null
                },
            })
                .then((res) => {
                    const { state, msg } = res.data;
                    if (state == 1) {
                        this.$confirm('下载任务创建成功,可以在下载任务列表查看', '提示', {
                            confirmButtonText: '立即查看',
                            cancelButtonText: '稍后再看',
                            type: 'success',
                            center: true,
                            closeOnClickModal: false
                        }).then(() => {
                            this.$router.push({ path: '/workbench/downloadList' })
                        }).catch(() => { })
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.downLoading = false;
                });
        },
        //全选、反选
        handleSelectionChange(val) {
            this.joinUserIds = val.map(v => v.id);
        },
        //确认获奖
        handleAward(){
            if (this.joinUserIds.length < 1) {
                return this.$message.warning('请选择获奖用户');
            } else {
                this.$refs.confirmAward.show(this.joinUserIds)
            }
        }
    }
};
</script>
